import {Tag} from "antd";
import React from "react";

export function paymentStatus(value) {
    switch (value) {
        case "ODENMEDI":
            return <Tag color="red">Ödenmedi</Tag> ;
        case "ODENDI":
            return <Tag color="green">Ödendi</Tag>;
        default:
            return "";
    }
}

export function deliveryStatus(value) {
    switch (value) {
        case "TESLIM_EDILMEDI":
            return <Tag color="red">Teslim Edilmedi</Tag>;
        case "TESLIM_EDILDI":
            return <Tag color="green">Teslim Edildi</Tag>;
        default:
            return "";
    }
}

export function formatDate(dateString) {
    const date = new Date(dateString);
    const monthNames = [
      "January", "February", "March",
      "April", "May", "June", "July",
      "August", "September", "October",
      "November", "December"
    ];
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return monthNames[monthIndex] + ' ' + year;
}

export function getPaymentColumn(){
    return [
        {value:"vknTckn",label:"Ödeme VKN/TCKN"},
        {value:"clientVkn/Tckn",label:"Referans VKN/TCKN"},
        {value:"formattedName",label:"Unvan"},
        {value:"directorate",label:"Müdürlük Bilgisi"},
        {value:"",label: "Belge Bilgisi"},
        {value:"city",label:"Şehir"},
        {value:"amount",label:"Ödenecek Tutar"},
        {value:"date",label:"Tarih"}
    ];
}

export const paymentStatusType = {
    PENDING: "PENDING",
    ERROR: "ERROR",
    SUCCESS: "SUCCESS"
};


// WEBPACK FOOTER //
// ./src/util/Helpers.js